<div *ngIf="!isSubmitSucceeded && !submitFail">
  <ng-container [formGroup]="SupplierRegistrationAprovalForm" #supplierRegistrationAprovalForm>
    <div class="form-container" #supplierRegistrationAprovalDecision>
      <!-- Supplier Registration Aproval Decision Section -->
      <div class="form-section">
        <h4 class="section-title">{{'ADMIN_USER.SUPPPLIER_FORMS.SupplierRegistrationAproval'| translate}}</h4>
        <!---Aproval Decision Radio Buttons-->
        <div class="form-group">
          <div class="custom-Radio">
            <input type="radio" formControlName="AprovalDecision" id="radioAccept" name="AprovalDecision" value=1
              (change)="onDecisionChange()" />
            <label for="radioAccept">{{'ADMIN_USER.SUPPPLIER_FORMS.Accept'| translate}}</label>
          </div>
          <div class="custom-Radio">
            <input type="radio" formControlName="AprovalDecision" id="radioReject" name="AprovalDecision" value=0
              (change)="onDecisionChange()" />
            <label for="radioReject">{{'ADMIN_USER.SUPPPLIER_FORMS.Reject'| translate}}</label>
          </div>
          <div *ngIf="isFormSubmitted && getFormControls?.AprovalDecision?.invalid" class="red ">
            <div *ngIf="getFormControls?.AprovalDecision?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required'| translate}}
            </div>
          </div>
        </div>
        <!---Rejection Reason Text Area-->
        <div *ngIf="showRejectionReason" class="form-group">
          <label for="txtRejectionReason">{{'ADMIN_USER.SUPPPLIER_FORMS.RejectionReason'| translate}}</label>
          <span class="red">*</span>
          <textarea formControlName="RejectionReason" id="txtRejectionReason" class="form-control"
            name="txtRejectionReason"></textarea>
          <div *ngIf="isFormSubmitted && getFormControls?.RejectionReason?.invalid" class="red ">
            <div *ngIf="getFormControls?.RejectionReason?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required'| translate}}
            </div>
            <div *ngIf="getFormControls?.RejectionReason?.errors?.startsWithSpaceError">
              {{'FRONT_USER.START_WITH_SPACE' | translate}}
            </div>
            <div *ngIf="getFormControls?.RejectionReason?.errors?.maxlength">
              {{'FRONT_USER.TEXT_MAX_LENGTH_500_ERROR' | translate}}
            </div>
          </div>
        </div>
        <!-- Rejection Mail Checkbox -->
        <div *ngIf="showRejectionReason" class="form-group">
          <div class="custom-checkbox">
            <input type="checkbox" formControlName="RejectionMail" id="chkRejectionMail" name="chkRejectionMail" checked>
            <label for="chkRejectionMail">{{'ADMIN_USER.SUPPPLIER_FORMS.RejectionMail'| translate}}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- Submt Button -->
    <div class="form-group">
      <button type="button" class="btn SCAcustomBtn"
        (click)="submit()">{{'ADMIN_USER.SUPPPLIER_FORMS.Submit'| translate}}</button>
    </div>
  </ng-container>
</div>

<!-- Approval Confirmation Success -->
<div *ngIf="isSubmitSucceeded && !isTaskCompletedByAnotherUser" class="alert alert-success" role="alert">
  <div class="alignC">
    <i class="icon-success"></i>
    <p>{{'ADMIN_USER.SUPPPLIER_FORMS.DecisionSubmited'| translate}}</p>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
    </p>
  </div>
</div>

<!-- Approval Fail -->
<div *ngIf="submitFail" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>
    <hr>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
    </p>
  </div>
</div>

<!-- Task Completed By Another User Warning -->
<div *ngIf="isTaskCompletedByAnotherUser" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-warning"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.TaskCompletedByAnotherUser' | translate}}</p>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
    </p>
  </div>
</div>
